import { useField, useFormikContext } from 'formik';
import { BaseCheckboxFormControl } from '../BaseCheckboxFormControl/BaseCheckboxFormControl';
import { GoMotoComponent } from '../../../../API/GoMoto.types';
import { GMFormCheckboxFormControlProps } from '../..';
import { memo, useCallback } from 'react';

/**
 * Checkbox form control for use in a Formik.
 *
 * Sets the value & onChange internally
 */
const FormCheckboxFormControl: GoMotoComponent<GMFormCheckboxFormControlProps> = memo(({ onChange: propsOnChange, ...props }) => {
    const [field] = useField(props.name);
    // we don't use helpers above since those references change every render
    const { setFieldValue, setFieldTouched } = useFormikContext();

    const onChange = useCallback((_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
        if (propsOnChange) {
            propsOnChange(checked);
            setFieldTouched(props.name, true, false);
        }
        else {
            setFieldValue(props.name, checked);
            setFieldTouched(props.name, true, false);
        }
    }, [props.name, setFieldValue, propsOnChange, setFieldTouched]);

    return (
        <BaseCheckboxFormControl
            checked={field.value ?? false}
            onChange={onChange}
            {...props}
        />
    );
});

export default FormCheckboxFormControl;